import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { API_BASE_URL } from "@/utils/api";

const ResetPassword: React.FC = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{
    type: "error" | "success";
    text: string;
  } | null>(null);

  // ✅ Fix: atur body styling via useEffect, bukan CSS-in-JS
  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.minHeight = "100vh";
    document.body.style.backgroundColor = "#F9FAFB";
    document.body.style.display = "flex";
    document.body.style.alignItems = "center";
    document.body.style.justifyContent = "center";
    document.body.style.fontFamily = "'Inter', sans-serif";

    return () => {
      // Cleanup saat komponen unmount
      document.body.style.cssText = "";
    };
  }, []);

  const handleReset = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);

    if (password !== confirmPassword) {
      setMessage({ type: "error", text: "Password tidak sama!" });
      return;
    }

    if (password.length < 8) {
      setMessage({ type: "error", text: "Password minimal 8 karakter." });
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/reset-password/${id}/${token}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ newPassword: password }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage({
          type: "success",
          text: "Berhasil! Mengarahkan ke halaman login...",
        });
        setTimeout(() => navigate("/auth/login"), 2000);
      } else {
        setMessage({
          type: "error",
          text: data.message || "Link reset invalid atau kadaluarsa.",
        });
      }
    } catch {
      setMessage({ type: "error", text: "Gagal menghubungi server." });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .reset-container { 
          width: 100%; 
          max-width: 400px; 
          background: #FFFFFF; 
          border-radius: 16px; 
          padding: 40px; 
          text-align: center; 
          box-shadow: 0 4px 20px rgba(0,0,0,0.08);
          border: 1px solid #EEEEEE;
          margin: auto;
        }
        .reset-container h2 { 
          margin-bottom: 8px; 
          color: #1A1A1A; 
          font-size: 24px;
          font-weight: 700;
        }
        .reset-container p {
          color: #666;
          font-size: 14px;
          margin-bottom: 24px;
        }
        .reset-input { 
          width: 100%; 
          padding: 14px; 
          margin-bottom: 16px; 
          border-radius: 8px; 
          border: 1.5px solid #E5E7EB; 
          font-size: 14px;
          box-sizing: border-box;
          transition: border-color 0.2s;
        }
        .reset-input:focus {
          outline: none;
          border-color: #FF0000;
        }
        .btn-submit { 
          width: 100%; 
          padding: 14px; 
          background: #FF0000; 
          color: white; 
          border: none; 
          border-radius: 8px; 
          font-weight: 600; 
          cursor: pointer; 
          font-size: 16px;
          transition: opacity 0.2s;
        }
        .btn-submit:hover { opacity: 0.9; }
        .btn-submit:disabled { background: #CCCCCC; cursor: not-allowed; }
        .alert-error {
          background: #FEE2E2;
          color: #B91C1C;
          padding: 12px;
          border-radius: 8px;
          font-size: 13px;
          margin-bottom: 16px;
        }
        .alert-success {
          background: #DCFCE7;
          color: #15803D;
          padding: 12px;
          border-radius: 8px;
          font-size: 13px;
          margin-bottom: 16px;
        }
      `}</style>

      <div className="reset-container">
        <h2>Atur Ulang Kata Sandi</h2>
        <p>Silakan masukkan kata sandi baru Anda di bawah ini.</p>

        {message && (
          <div
            className={
              message.type === "error" ? "alert-error" : "alert-success"
            }
          >
            {message.text}
          </div>
        )}

        <form onSubmit={handleReset}>
          <input
            className="reset-input"
            type="password"
            placeholder="Kata Sandi Baru (min. 8 karakter)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <input
            className="reset-input"
            type="password"
            placeholder="Konfirmasi Kata Sandi"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
          <button type="submit" className="btn-submit" disabled={isLoading}>
            {isLoading ? "Memproses..." : "Simpan Perubahan"}
          </button>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
